import { useStore } from "@/stores/useStore";

export const useEmployees = (withAuth?: boolean) => {
  const employees = useStore((state) => state.employees) ?? [];

  if (withAuth === undefined) {
    return employees;
  }

  if (withAuth) {
    return employees.filter((employee) => !!employee.shopHeroAuthUid);
  }

  return employees.filter((employee) => !employee.shopHeroAuthUid);
};
